import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes";
import lightningChecksLogo from "../../assets/img/mainlogo.png";
import bm2bankLogo from "../../assets/img/paxum.svg";
import bm2payLogo from "../../assets/img/bm2pay.svg";
import { Modal, ModalContent, ModalBody, ModalOverlay } from "@chakra-ui/modal";
import Card from "components/card";
import { useContext, useEffect, useState } from "react";
import { ClientContext } from "ClientProvider";
import { getSettings } from "api/settings";

let mainlogo: string = bm2payLogo;
if (["gateway-dev.lightningchecks.com","gateway.lightningchecks.com","testing.lightningchecks.com"].includes(window.location.hostname)) {
  mainlogo = lightningChecksLogo;
} else if (["gateway-dev.bm2pay.com","gateway.bm2pay.com","gateway-stagging.bm2pay.com"].includes(window.location.hostname)) {
  mainlogo = bm2payLogo;
} else if (window.location.hostname === "pay.paxum.com") {
  mainlogo = bm2bankLogo;
} else {
  mainlogo = bm2payLogo;
}

const LIGHTNING_HOSTS = ["gateway-dev.lightningchecks.com","gateway.lightningchecks.com","testing.lightningchecks.com","localhost"];
const BM2PAY_HOSTS = ["gateway-dev.bm2pay.com","gateway.bm2pay.com","gateway-stagging.bm2pay.com"];
const PAXUM_HOSTS = ["pay.paxum.com"];

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  const [portalIcon, setPortalIcon] = useState<string | null>(mainlogo);
  const clientId = localStorage.getItem("clietnIds");
  const {
    SettlementAPISttus, setisOpenSettlementAPISttus,
    isOpenSettlementAPISttus,
  } = useContext(ClientContext);

  const isLightningChecks = LIGHTNING_HOSTS.includes(window.location.hostname);
  const isBm2Pay = BM2PAY_HOSTS.includes(window.location.hostname);
  const isPaxum = PAXUM_HOSTS.includes(window.location.hostname);

  const updatedRoutes = routes.map((route) => {
    if (route.name === "Smart Routing") {
      return { ...route, isHidden: clientId === null, hideInSidebar: clientId === null };
    }
    return route;
  });

  useEffect(() => {
    getSettings(false)
      .then((data) => setPortalIcon(data.portal_icon))
      .catch(() => {});
  }, []);

  return (
    <>
      <div className={`sb-root${open ? " sb-root--open" : " sb-root--closed"}`}>

        {/* ── Close button (mobile only) ── */}
        <span className="sb-close-btn" onClick={onClose} role="button" aria-label="Close sidebar">
          <HiX size={15} />
        </span>

        {/* ═══════════════════════════════
            BRAND ZONE
        ═══════════════════════════════ */}
        <div className="sb-brand-zone">
          <div className="sb-brand-logo-wrap">
            <img src={portalIcon} className="sb-brand-logo" alt="Portal logo" id="portalIcon" />
          </div>
          <div className="sb-brand-identity">
            {isLightningChecks && (
              <>
                <span className="sb-brand-name">LIGHTNING</span>
                <span className="sb-brand-sub">checks · portal</span>
              </>
            )}
            {isBm2Pay && (
              <>
                <span className="sb-brand-name">BM2PAY</span>
                <span className="sb-brand-sub">portal</span>
              </>
            )}
            {isPaxum && (
              <>
                <span className="sb-brand-name">PAXUM</span>
                <span className="sb-brand-sub">portal</span>
              </>
            )}
          </div>
        </div>

        {/* ═══════════════════════════════
            NAV SECTION HEADER
        ═══════════════════════════════ */}
        <div className="sb-section-header">
          <span className="sb-section-label">Menu</span>
          <div className="sb-section-line" />
        </div>

        {/* ═══════════════════════════════
            NAVIGATION
        ═══════════════════════════════ */}
        <nav
          className="sb-nav"
          onMouseEnter={() => {
            if (SettlementAPISttus === "in-progress") setisOpenSettlementAPISttus(true);
            else setisOpenSettlementAPISttus(false);
          }}
        >
          <Links routes={updatedRoutes.filter((d) => d.layout === "/admin")} onClose={onClose} />
        </nav>

        {/* ═══════════════════════════════
            FOOTER
        ═══════════════════════════════ */}
        <div className="sb-footer">
          {/* Status row */}
          <div className="sb-footer-status-row">
            <span className="sb-status-pulse" />
            <span className="sb-status-text">All systems operational</span>
          </div>
          {/* Copyright */}
          <div className="sb-footer-meta">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>© {new Date().getFullYear()} · SSL Encrypted</span>
          </div>
        </div>

        {/* Settlement modal */}
        <Modal isOpen={isOpenSettlementAPISttus} onClose={() => {}}>
          <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
          <ModalContent className="sm:max-w-xxl scrollbarhide z-[1002] !m-auto flex max-h-[100vh] min-h-[85vh] max-w-[800px] justify-start overflow-auto !p-3 sm:my-8 sm:w-full">
            <ModalBody>
              <Card extra="max-w-[800px] sm:w-full flex flex-col justify-start !z-[1004] scrollbarhide overflow-auto">
                <h5 className="p-5 px-[30px] text-2xl font-bold">Settlement Report is being created.</h5>
                <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                  <button onClick={() => setisOpenSettlementAPISttus(false)} className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200">Close</button>
                  <button onClick={() => setisOpenSettlementAPISttus(false)} className="linear rounded-xl bg-indigo-50 px-5 py-2 text-base font-medium text-indigo-500 outline-none transition duration-200 hover:bg-indigo-600/5">
                    <a target="_blank" href="/" rel="noreferrer">Open in New Tab</a>
                  </button>
                </div>
              </Card>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* ── Root ── */
        .sb-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; left: 0; top: 0;
          height: 100vh; width: 256px;
          z-index: 50;
          display: flex; flex-direction: column;
          background: #ffffff;
          border-right: 1px solid #eef0f6;
          box-shadow: 6px 0 32px rgba(15,23,42,0.07);
          transition: transform 0.3s cubic-bezier(0.16,1,0.3,1);
          overflow: hidden;
        }
        .sb-root--open  { transform: translateX(0); }
        .sb-root--closed { transform: translateX(-100%); }
        @media (min-width: 1280px) {
          .sb-root { transform: translateX(0) !important; }
          .sb-close-btn { display: none !important; }
        }

        /* ── Close btn ── */
        .sb-close-btn {
          position: absolute; top: 12px; right: 12px;
          width: 26px; height: 26px; border-radius: 7px;
          display: flex; align-items: center; justify-content: center;
          background: rgba(255,255,255,0.8); border: 1px solid #e2e8f0;
          color: #64748b; cursor: pointer; transition: all .15s; z-index: 10;
        }
        .sb-close-btn:hover { background: #f1f5f9; color: #0f172a; }

        /* ══════════════════════════
           BRAND ZONE
        ══════════════════════════ */
        .sb-brand-zone {
          flex-shrink: 0;
          display: flex; align-items: center; gap: 12px;
          padding: 16px 16px 16px;
          background: linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%);
          border-bottom: 1.5px solid #dde6f8;
          position: relative;
        }
        /* subtle top accent stripe */
        .sb-brand-zone::before {
          content: '';
          position: absolute; top: 0; left: 0; right: 0; height: 3px;
          background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb);
          background-size: 200% 100%;
          animation: sbGradShift 4s linear infinite;
        }
        @keyframes sbGradShift { 0%{background-position:0%} 100%{background-position:200%} }

        .sb-brand-logo-wrap {
          width: 42px; height: 42px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          background: #ffffff;
          border-radius: 12px;
          border: 1.5px solid #c7d9f8;
          box-shadow: 0 3px 12px rgba(37,99,235,0.14);
          overflow: hidden; padding: 5px;
        }
        .sb-brand-logo { width: 100%; height: 100%; object-fit: contain; }

        .sb-brand-identity {
          display: flex; flex-direction: column; gap: 2px; min-width: 0;
        }
        .sb-brand-name {
          font-size: 15px; font-weight: 800; color: #1e3a8a;
          letter-spacing: -0.3px; line-height: 1.2;
        }
        .sb-brand-sub {
          font-size: 10px; font-weight: 600;
          color: #6b8cc7; letter-spacing: 0.3px;
        }

        /* ══════════════════════════
           SECTION HEADER
        ══════════════════════════ */
        .sb-section-header {
          flex-shrink: 0;
          display: flex; align-items: center; gap: 8px;
          padding: 14px 18px 4px;
        }
        .sb-section-label {
          font-size: 9.5px; font-weight: 800; letter-spacing: 1.2px;
          text-transform: uppercase; color: #b8c4d8; white-space: nowrap;
        }
        .sb-section-line {
          flex: 1; height: 1px;
          background: linear-gradient(90deg, #e4e9f4 0%, transparent 100%);
        }

        /* ══════════════════════════
           NAV
        ══════════════════════════ */
        .sb-nav {
          flex: 1; overflow-y: auto; overflow-x: hidden;
          padding: 2px 0 8px;
        }
        .sb-nav::-webkit-scrollbar { width: 3px; }
        .sb-nav::-webkit-scrollbar-thumb { background: #dde3ec; border-radius: 3px; }
        .sb-nav::-webkit-scrollbar-track { background: transparent; }

        /* ══════════════════════════
           FOOTER
        ══════════════════════════ */
        .sb-footer {
          flex-shrink: 0;
          padding: 11px 16px 15px;
          border-top: 1.5px solid #eef2fb;
          background: linear-gradient(135deg, #f8faff 0%, #f3f6fe 100%);
          display: flex; flex-direction: column; gap: 6px;
        }

        .sb-footer-status-row {
          display: flex; align-items: center; gap: 8px;
        }
        .sb-status-pulse {
          width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0;
          background: #16a34a;
          box-shadow: 0 0 0 2px rgba(22,163,74,0.2);
          animation: sbStatusPulse 2.8s ease-in-out infinite;
        }
        @keyframes sbStatusPulse {
          0%,100% { box-shadow: 0 0 0 2px rgba(22,163,74,0.18); }
          50%      { box-shadow: 0 0 0 5px rgba(22,163,74,0.06); }
        }
        .sb-status-text {
          font-size: 11px; font-weight: 700; color: #16a34a;
        }

        .sb-footer-meta {
          display: flex; align-items: center; gap: 5px;
          font-size: 10px; font-weight: 500; color: #b8c4d8;
        }

        /* ══════════════════════════
           DARK MODE
        ══════════════════════════ */
        .dark .sb-root {
          background: #0f172a;
          border-right-color: rgba(255,255,255,0.06);
          box-shadow: 6px 0 32px rgba(0,0,0,0.45);
        }
        .dark .sb-brand-zone {
          background: linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(124,58,237,0.08) 100%);
          border-bottom-color: rgba(255,255,255,0.07);
        }
        .dark .sb-brand-logo-wrap {
          background: rgba(255,255,255,0.06);
          border-color: rgba(255,255,255,0.12);
          box-shadow: 0 3px 12px rgba(0,0,0,0.3);
        }
        .dark .sb-brand-name { color: #c7d9ff; }
        .dark .sb-brand-sub  { color: rgba(255,255,255,0.35); }
        .dark .sb-section-label { color: rgba(255,255,255,0.2); }
        .dark .sb-section-line  { background: linear-gradient(90deg, rgba(255,255,255,0.08), transparent); }
        .dark .sb-footer {
          background: linear-gradient(135deg, rgba(255,255,255,0.03) 0%, rgba(37,99,235,0.06) 100%);
          border-top-color: rgba(255,255,255,0.07);
        }
        .dark .sb-footer-meta { color: rgba(255,255,255,0.2); }
        .dark .sb-close-btn {
          background: rgba(255,255,255,0.07); border-color: rgba(255,255,255,0.1); color: #94a3b8;
        }
        .dark .sb-close-btn:hover { background: rgba(255,255,255,0.12); color: #e2e8f0; }
      `}</style>
    </>
  );
};

export default Sidebar;